import { apiClient } from './api_base';

// Profile API endpoints
export const fetchProfile = async () => {
    try {
        const response = await apiClient.get('/affiliates/profile');
        return response;
    } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
    }
};

export const updateProfile = async (profileData) => {
    try {
        console.log('API: Received profile data:', profileData);
        
        const formData = new FormData();
        
        // Add text fields
        if (profileData.name) formData.append('name', profileData.name);
        if (profileData.email) formData.append('email', profileData.email);
        if (profileData.phone) formData.append('phone', profileData.phone);
        if (profileData.address) formData.append('address', profileData.address);
        if (profileData.city) formData.append('city', profileData.city);
        if (profileData.imageFile) {
            // Send both keys for backend compatibility.
            formData.append('image', profileData.imageFile);
            formData.append('image_file', profileData.imageFile);
        }
        
        console.log('API: FormData contents:');
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        
        const response = await apiClient.post('/affiliates/profile', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        console.error('Error updating profile:', error);
        throw error;
    }
};

export const deleteProfileImage = async () => {
    try {
        const response = await apiClient.delete('/affiliates/profile/image');
        return response;
    } catch (error) {
        console.error('Error deleting profile image:', error);
        throw error;
    }
};

export const getProfileImageUrl = async () => {
    try {
        const response = await apiClient.get('/affiliates/profile/image-url');
        return response;
    } catch (error) {
        console.error('Error getting profile image URL:', error);
        throw error;
    }
};
